import { FC, ReactNode, SVGProps } from 'react';

// 프리텐다드
import { ReactComponent as PretendardKrPc } from './images/font-images/pretendard-kr-pc.svg';
import { ReactComponent as PretendardKrTablet } from './images/font-images/pretendard-kr-tablet.svg';
import { ReactComponent as PretendardKrMobile } from './images/font-images/pretendard-kr-mobile.svg';

import { ReactComponent as PretendardEnPc } from './images/font-images/pretnedard-en-pc.svg';
import { ReactComponent as PretendardEnTablet } from './images/font-images/pretendard-en-tablet.svg';
import { ReactComponent as PretendardEnMobile } from './images/font-images/pretendard-en-mobile.svg';

// 현대 산스
import { ReactComponent as HyundaiKrPc } from './images/font-images/hyundai-kr-pc.svg';
import { ReactComponent as HyundaiKrTablet } from './images/font-images/hyundai-kr-tablet.svg';
import { ReactComponent as HyundaiKrMobile } from './images/font-images/hyundai-kr-mobile.svg';

import { ReactComponent as HyundaiEnPc } from './images/font-images/hyundai-en-pc.svg';
import { ReactComponent as HyundaiEnTablet } from './images/font-images/hyundai-en-tablet.svg';
import { ReactComponent as HyundaiEnMobile } from './images/font-images/hyundai-en-mobile.svg';

// 노토 산스
import { ReactComponent as NotoSansKrPc } from './images/font-images/noto-sans-kr-pc.svg';
import { ReactComponent as NotoSansKrTablet } from './images/font-images/noto-sans-kr-tablet.svg';
import { ReactComponent as NotoSansKrMobile } from './images/font-images/noto-sans-kr-mobile.svg';

import { ReactComponent as NotoSansEnPc } from './images/font-images/noto-sans-en-pc.svg';
import { ReactComponent as NotoSansEnTablet } from './images/font-images/noto-sans-en-tablet.svg';
import { ReactComponent as NotoSansEnMobile } from './images/font-images/noto-sans-en-mobile.svg';

// 수트
import { ReactComponent as SuitKrPc } from './images/font-images/suit-kr-pc.svg';
import { ReactComponent as SuitKrTablet } from './images/font-images/suit-kr-tablet.svg';
import { ReactComponent as SuitKrMobile } from './images/font-images/suit-kr-mobile.svg';

import { ReactComponent as SuitEnPc } from './images/font-images/suit-en-pc.svg';
import { ReactComponent as SuitEnTablet } from './images/font-images/suit-en-tablet.svg';
import { ReactComponent as SuitEnMobile } from './images/font-images/suit-en-mobile.svg';

type PortfolioFontType = {
	kr: {
		pc: FC<SVGProps<SVGSVGElement>>;
		tablet: FC<SVGProps<SVGSVGElement>>;
		mobile: FC<SVGProps<SVGSVGElement>>;
	};
	en: {
		pc: FC<SVGProps<SVGSVGElement>>;
		tablet: FC<SVGProps<SVGSVGElement>>;
		mobile: FC<SVGProps<SVGSVGElement>>;
	};
};

export type PortfolioFontKey = 'PRETENDARD' | 'HYUNDAI' | 'NOTOSANS' | 'SUIT';

export const PORTFOLIO_FONT: Record<PortfolioFontKey, PortfolioFontType> = {
	PRETENDARD: {
		kr: {
			pc: PretendardKrPc,
			tablet: PretendardKrTablet,
			mobile: PretendardKrMobile
		},
		en: {
			pc: PretendardEnPc,
			tablet: PretendardEnTablet,
			mobile: PretendardEnMobile
		}
	},
	HYUNDAI: {
		kr: {
			pc: HyundaiKrPc,
			tablet: HyundaiKrTablet,
			mobile: HyundaiKrMobile
		},
		en: {
			pc: HyundaiEnPc,
			tablet: HyundaiEnTablet,
			mobile: HyundaiEnMobile
		}
	},
	NOTOSANS: {
		kr: {
			pc: NotoSansKrPc,
			tablet: NotoSansKrTablet,
			mobile: NotoSansKrMobile
		},
		en: {
			pc: NotoSansEnPc,
			tablet: NotoSansEnTablet,
			mobile: NotoSansEnMobile
		}
	},
	SUIT: {
		kr: {
			pc: SuitKrPc,
			tablet: SuitKrTablet,
			mobile: SuitKrMobile
		},
		en: {
			pc: SuitEnPc,
			tablet: SuitEnTablet,
			mobile: SuitEnMobile
		}
	}
} as const;

export type PortfolioFont =
	(typeof PORTFOLIO_FONT)[keyof typeof PORTFOLIO_FONT];
